import React from 'react'

const Preloader = ({ className = '' }: { className?: string }) => {
    // global classname, described in `index.html`
	return <div className={`preloader c-preloader ${className}`} />
}

export default Preloader
